import { useTranslation } from 'next-i18next'

import ResponsiveImage from '~/components/Image/ResponsiveImage'
import SVGIcon from '~/components/Icons/svgs/SVGIcon'
import StarIcon from '~/components/Icons/svgs/StarIcon'
import { range } from '~/utils/helpers'

import { Reviewer } from './Testimonials.const'

const mediaQuery = [{ screen: '(min-width: 280px)', width: '200px' }]

export default function TestimonialItem({
  reviewerKey,
  imageSrcKey,
  name,
}: {
  reviewerKey: Reviewer
  imageSrcKey: string
  name: string
}): React.ReactElement {
  const { t } = useTranslation('tutorOnDemand')

  return (
    <div className="relative bg-white h-full rounded md:shadow-large p-0.5 bg-gradient-orange-pink-blue">
      <div className="z-10 h-full p-3 flex flex-col bg-white rounded">
        <section className="space-y-2">
          <QuoteIcon />
          <Stars />
          <q className="block text-black-light">{t(`landingPage.reviews.quotes.${reviewerKey}`)}</q>
        </section>
        <div className="mt-auto space-x-1 flex flex-col items-end">
          <ResponsiveImage
            alt={`Review from ${name}`}
            height={200}
            imageClassName="w-24 h-24"
            imageWidths="200"
            loading="lazy"
            mediaQuery={mediaQuery}
            srcKey={imageSrcKey}
            width={200}
          />
          <span className="text-xs">{name}</span>
          <span className="text-xs text-black-light-fade">{t(`landingPage.reviews.roles.${reviewerKey}`)}</span>
        </div>
      </div>
    </div>
  )
}

function QuoteIcon(): React.ReactElement {
  return (
    <svg fill="none" height="36" viewBox="0 0 42 36" width="42" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M41.3665 2.84919C40.1511 4.17185 38.9893 5.56601 37.8811 7.03166C36.8087 8.49731 35.8435 9.98084 34.9856 11.4822C34.1276 12.9836 33.3948 14.4672 32.7871 15.9328C32.1794 17.3627 31.7504 18.6854 31.5002 19.9008C31.8934 20.294 32.376 20.6872 32.948 21.0805C33.5557 21.4737 34.1991 21.849 34.8783 22.2065C35.5575 22.564 36.2546 22.8857 36.9696 23.1717C37.6845 23.4219 38.3637 23.6185 39.0072 23.7615C39.2932 24.262 39.4898 24.8518 39.597 25.531C39.7043 26.2103 39.7579 26.8001 39.7579 27.3006C39.7579 28.1585 39.5791 29.0522 39.2217 29.9816C38.8999 30.9111 38.4173 31.769 37.7739 32.5555C37.1304 33.3419 36.3082 33.9854 35.3073 34.4858C34.3421 34.9863 33.2161 35.2365 31.9292 35.2365C30.9282 35.2365 29.9273 35.0578 28.9264 34.7003C27.9612 34.3071 27.0853 33.6994 26.2989 32.8772C25.5125 32.055 24.869 31.0004 24.3685 29.7135C23.9038 28.3909 23.6715 26.8001 23.6715 24.9412C23.6715 23.2253 23.9396 21.4022 24.4758 19.4718C25.012 17.5057 25.8521 15.486 26.996 13.4126C28.1757 11.3035 29.6771 9.15864 31.5002 6.97804C33.3233 4.79743 35.5039 2.6347 38.042 0.489845L41.3665 2.84919ZM18.2021 2.84919C16.9866 4.17185 15.8249 5.56601 14.7167 7.03166C13.6442 8.49731 12.6791 9.98084 11.8211 11.4822C10.9632 12.9836 10.2303 14.4672 9.62264 15.9328C9.01493 17.3627 8.58596 18.6854 8.33573 19.9008C8.72895 20.294 9.21154 20.6872 9.7835 21.0805C10.3912 21.4737 11.0347 21.849 11.7139 22.2065C12.3931 22.564 13.0902 22.8857 13.8051 23.1717C14.5201 23.4219 15.1993 23.6185 15.8427 23.7615C16.1287 24.262 16.3253 24.8518 16.4326 25.531C16.5398 26.2103 16.5934 26.8001 16.5934 27.3006C16.5934 28.1585 16.4147 29.0522 16.0572 29.9816C15.7355 30.9111 15.2529 31.769 14.6094 32.5555C13.966 33.3419 13.1438 33.9854 12.1428 34.4858C11.1777 34.9863 10.0516 35.2365 8.7647 35.2365C7.76376 35.2365 6.76283 35.0578 5.7619 34.7003C4.79671 34.3071 3.9209 33.6994 3.13445 32.8772C2.348 32.055 1.70454 31.0004 1.20408 29.7135C0.739358 28.3909 0.506999 26.8001 0.506999 24.9412C0.506999 23.2253 0.775106 21.4022 1.31132 19.4718C1.84753 17.5057 2.6876 15.486 3.83153 13.4126C5.0112 11.3035 6.5126 9.15864 8.33573 6.97804C10.1589 4.79743 12.3395 2.6347 14.8775 0.489845L18.2021 2.84919Z"
        fill="#817C87"
      />
    </svg>
  )
}

function Stars(): React.ReactElement {
  return (
    <div className="space-x-1 flex justify-center">
      {range(5).map((elem) => (
        <SVGIcon icon={StarIcon} key={elem} pathClassName="text-orange" size={20} />
      ))}
    </div>
  )
}
